exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-input-modal .v-card__title[data-v-8361cac8] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.file-input-modal .v-card__title span[data-v-8361cac8] {\n  font-size: 14px;\n}\n", ""]);

// exports
